class CartModal {
  constructor(global_modal) {
    this.global_modal = global_modal;
    this.modal_is_open = false;
    if (this.global_modal !== null) {
      this._maybeCloseModal = this._maybeCloseModal.bind(this);
      this._closeModal = this._closeModal.bind(this);

      this.productTemplate = this.global_modal.querySelector(
        '[data-element="product"]',
      );
      this.productTemplate.remove();

      document.addEventListener("click", this._maybeCloseModal);

      let modalClose = this.global_modal.querySelectorAll(
        '[data-element="close"]',
      );
      if (modalClose.length > 0) {
        modalClose.forEach((mc) => {
          mc.addEventListener("click", this._closeModal);
        });
      }
    }
  }

  displayModal(message, type = "success", data, product_qty = 1) {
    if (this.global_modal !== null) {
      let title = this.global_modal.querySelector('[data-element="title"]');
      let content = this.global_modal.querySelector('[data-element="content"]');

      if (type === "success") {
        title.innerHTML = message;

        let tmp = content.querySelector('[data-element="product"]');
        if (tmp !== null) {
          tmp.remove();
        }

        let product = this._createProduct(data, product_qty);
        content.prepend(product);
      }

      this.global_modal.classList.add("modal--shown");
      this.modal_is_open = true;
    }
  }

  _createProduct(data, product_qty) {
    let product = this.productTemplate.cloneNode(true);
    let name = product.querySelector('[data-element="name"]');
    let image = product.querySelector('[data-element="image"]');
    let price = product.querySelector('[data-element="price"]');
    let amount = product.querySelector('[data-element="amount"]');

    image.src = data.product.product.image;
    image.alt = data.product.product.name;
    name.innerHTML = data.product.product.name;
    name.href = data.product.product.link;
    price.innerHTML = data.product.product.price;
    amount.innerHTML = product_qty;

    return product;
  }

  _maybeCloseModal(event) {
    if (this.global_modal !== null) {
      if (this.modal_is_open) {
        let modal = event.target.closest(".js-cart-modal");
        if (modal === null) {
          this.global_modal.classList.remove("modal--shown");
          this.modal_is_open = false;
        }
      }
    }
  }

  _closeModal(event) {
    event.preventDefault();
    this.global_modal.classList.remove("modal--shown");
    this.modal_is_open = false;
  }
}

export default CartModal;
